import React from 'react';
import { Radio, RadioChangeEvent } from 'antd';

interface Option {
  id: string;
  label: string;
}

interface TabsProp {
  options: Option[];
  selectedOption: string;
  RadioGroupStyle?: React.CSSProperties;
  handleChange: (prop: RadioChangeEvent) => void;
}

function Tabs({ options, selectedOption, RadioGroupStyle, handleChange }: TabsProp) {
  return (
    <Radio.Group onChange={handleChange} value={selectedOption} style={RadioGroupStyle}>
      {options.map((opt) => (
        <Radio.Button key={opt.id} value={opt.id}>
          {opt.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
}

export default Tabs;
